import { render, staticRenderFns } from "./HeaderUserProfile.vue?vue&type=template&id=a3eff4c8&scoped=true&"
import script from "./HeaderUserProfile.vue?vue&type=script&lang=js&"
export * from "./HeaderUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserProfile.vue?vue&type=style&index=0&id=a3eff4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3eff4c8",
  null
  
)

export default component.exports